import { types } from '../../types/types';

const TYPING_TTL_MS = 10000;

const initialState = {
    typingByContact: {}, // { [id_contact]: { [email]: { displayName, lastAt } } }
};

const now = () => Date.now();

const pruneContact = (byEmail) => {
    const cutoff = now() - TYPING_TTL_MS;
    return Object.keys(byEmail).reduce((acc, email) => {
        if (byEmail[email].lastAt >= cutoff) acc[email] = byEmail[email];
        return acc;
    }, {});
};

export const typingReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.typingSet: {
            const { id_contact, email, displayName, lastAt } = action.payload;
            if (!id_contact || !email) return state;

            const byContact = { ...state.typingByContact };
            const byEmail = {
                ...pruneContact(byContact[id_contact] || {}),
                [email]: { displayName, lastAt: lastAt || now() },
            };
            byContact[id_contact] = byEmail;

            return { ...state, typingByContact: byContact };
        }

        case types.typingClear: {
            const { id_contact, email } = action.payload;
            if (!id_contact) return state;

            const byContact = { ...state.typingByContact };

            // Sin email → mensaje recibido: limpiar todo el typing del contacto
            if (!email) {
                delete byContact[id_contact];
                return { ...state, typingByContact: byContact };
            }

            const byEmail = pruneContact(byContact[id_contact] || {});
            delete byEmail[email];

            if (Object.keys(byEmail).length === 0) {
                delete byContact[id_contact];
            } else {
                byContact[id_contact] = byEmail;
            }

            return { ...state, typingByContact: byContact };
        }

        case types.typingPrune: {
            const byContact = state.typingByContact;
            const next = {};
            let changed = false;

            Object.keys(byContact).forEach((id_contact) => {
                const original = byContact[id_contact];
                const pruned = pruneContact(original);
                if (Object.keys(pruned).length === 0) {
                    changed = true; // contacto sin typing fresco → se elimina
                    return;
                }
                if (Object.keys(pruned).length !== Object.keys(original).length) {
                    changed = true;
                }
                next[id_contact] = pruned;
            });

            return changed ? { ...state, typingByContact: next } : state;
        }

        default:
            return state;
    }
};
